module.exports = __webpack_public_path__ + "img/album_7.6c0c4adb.jpg";